import { random, round2 } from "../helpers/helpers";

export const generateVibrationChartYearDemo = ({
                                                   meter_id,
                                                   year,
                                               }) => {
    const today = new Date();
    const isCurrentYear = today.getFullYear() === Number(year);
    const maxMonth = isCurrentYear ? today.getMonth() + 1 : 12;

    const monthly_energy_data = [];

    for (let month = 1; month <= maxMonth; month++) {
        const baseAcc1 = random(0.03, 0.15);
        const baseAcc2 = random(0.0, 0.05);
        const baseAcc3 = random(0.95, 1.05);

        const baseAxis1 = random(0, 3);
        const baseAxis2 = random(0, 2);
        const baseAxis3 = random(0, 1.5);

        const baseTemp = random(28, 34);

        monthly_energy_data.push({
            month,

            avg_acc_axis1: round2(baseAcc1),
            avg_acc_axis2: round2(baseAcc2),
            avg_acc_axis3: round2(baseAcc3),

            min_acc_axis1: "0.00",
            min_acc_axis2: "0.00",
            min_acc_axis3: round2(random(0.6, 0.9)),

            max_acc_axis1: round2(baseAcc1 + random(0.2, 0.9)),
            max_acc_axis2: round2(baseAcc2 + random(0.1, 0.3)),
            max_acc_axis3: round2(baseAcc3 + random(0.1, 0.3)),

            avg_axis1: round2(baseAxis1),
            avg_axis2: round2(baseAxis2),
            avg_axis3: round2(baseAxis3),

            min_axis1: "0.00",
            min_axis2: "0.00",
            min_axis3: "0.00",

            max_axis1: round2(baseAxis1 + random(2, 15)),
            max_axis2: round2(baseAxis2 + random(2, 10)),
            max_axis3: round2(baseAxis3 + random(2, 8)),

            avg_temp: round2(baseTemp),
            min_temp: round2(baseTemp - random(2, 4)),
            max_temp: round2(baseTemp + random(4, 9)),

            normal_limit: "4.50",
            marginal_limit: "11.20",
        });
    }

    return {
        meter_id: Number(meter_id),
        year: Number(year),
        monthly_energy_data,
    };
};
